/**
 * PDP "Exclusive Offer" blocks: copy-to-clipboard, drag-to-scroll, and the
 * custom scrollbar progress indicator for each group of consecutive
 * "Exclusive Offer" blocks (each group is wrapped in one
 * .exclusive-offers-section by snippets/product-blocks.liquid).
 *
 * Ported from sections/website-exclusive-offers.liquid's inline script, but
 * shared across however many offer groups exist on the page instead of one
 * copy per section instance.
 */
(function () {
  function closeAllOfferTooltips() {
    document.querySelectorAll('.offer-info-tooltip').forEach(function (tooltip) {
      tooltip.hidden = true;
    });
    document.querySelectorAll('.offer-info').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', closeAllOfferTooltips);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllOfferTooltips();
  });

  function initOffersSection(section) {
    if (section.dataset.offersInit === 'true') return;
    section.dataset.offersInit = 'true';

    var infoButtons = section.querySelectorAll('.offer-info');

    infoButtons.forEach(function (button) {
      var wrapper = button.closest('.offer-info-wrapper');
      var tooltip = wrapper && wrapper.querySelector('.offer-info-tooltip');
      if (!tooltip) return;

      button.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = !tooltip.hidden;
        closeAllOfferTooltips();

        if (!isOpen) {
          tooltip.hidden = false;
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });

    var copyButtons = section.querySelectorAll('.copy-code-btn');

    copyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var code = button.getAttribute('data-copy-code');
        var textElement = button.querySelector('.copy-text');
        if (!code) return;

        function showCopied() {
          button.classList.add('copied');
          var originalText = textElement.textContent;
          textElement.textContent = 'COPIED!';

          setTimeout(function () {
            textElement.textContent = originalText;
            button.classList.remove('copied');
          }, 1800);
        }

        function fallbackCopy(text) {
          var input = document.createElement('input');
          input.value = text;
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.appendChild(input);
          input.select();
          input.setSelectionRange(0, input.value.length);

          try {
            document.execCommand('copy');
            showCopied();
          } catch (error) {
            console.error('Unable to copy coupon code:', error);
          }

          document.body.removeChild(input);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(showCopied).catch(function () {
            fallbackCopy(code);
          });
        } else {
          fallbackCopy(code);
        }
      });
    });

    var list = section.querySelector('.offers-list');
    var progress = section.querySelector('.offers-scrollbar-progress');
    var scrollbar = section.querySelector('.offers-scrollbar');
    var prevButton = section.querySelector('.offers-slider-arrow-prev');
    var nextButton = section.querySelector('.offers-slider-arrow-next');

    if (!list) return;

    function getScrollAmount() {
      var card = list.querySelector('.offer-card');
      if (!card) return 0;

      var cardWidth = card.getBoundingClientRect().width;
      var computedStyle = window.getComputedStyle(list);
      var gap = parseFloat(computedStyle.gap) || 0;

      return cardWidth + gap;
    }

    function updateArrowState() {
      var maxScroll = list.scrollWidth - list.clientWidth;

      if (prevButton) {
        prevButton.disabled = list.scrollLeft <= 2;
      }

      if (nextButton) {
        nextButton.disabled = list.scrollLeft >= maxScroll - 2;
      }
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        list.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        list.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }

    function updateProgress() {
      if (!progress || !scrollbar) {
        updateArrowState();
        return;
      }

      var maxScroll = list.scrollWidth - list.clientWidth;

      if (maxScroll <= 0) {
        progress.style.width = '100%';
        progress.style.transform = 'translateX(0)';
        updateArrowState();
        return;
      }

      var trackWidth = scrollbar.clientWidth;
      var progressWidth = Math.max(50, (list.clientWidth / list.scrollWidth) * trackWidth);
      progress.style.width = progressWidth + 'px';

      var maxTranslate = trackWidth - progressWidth;
      var translate = (list.scrollLeft / maxScroll) * maxTranslate;
      progress.style.transform = 'translateX(' + translate + 'px)';

      updateArrowState();
    }

    list.addEventListener('scroll', updateProgress);
    window.addEventListener('resize', updateProgress);
    window.addEventListener('load', updateProgress);
    updateProgress();

    // Card widths/count can still shift after this first measurement (images
    // finishing load, web fonts swapping in, the theme editor resizing the
    // preview pane) - without this, a stale reading can leave the "next"
    // arrow permanently disabled since disabled buttons can't fire the
    // scroll/resize events that would otherwise correct it.
    if (typeof ResizeObserver !== 'undefined') {
      var resizeObserver = new ResizeObserver(function () {
        updateProgress();
      });
      resizeObserver.observe(list);
    }

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    list.addEventListener('mousedown', function (e) {
      if (e.target.closest('button, a')) return;

      isDown = true;
      list.style.cursor = 'grabbing';
      startX = e.pageX - list.offsetLeft;
      scrollLeft = list.scrollLeft;
    });

    list.addEventListener('mouseleave', function () {
      isDown = false;
      list.style.cursor = 'grab';
    });

    list.addEventListener('mouseup', function () {
      isDown = false;
      list.style.cursor = 'grab';
    });

    list.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - list.offsetLeft;
      var walk = (x - startX) * 1.5;
      list.scrollLeft = scrollLeft - walk;
    });
  }

  function initAll() {
    document.querySelectorAll('.exclusive-offers-section').forEach(initOffersSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
